import { useResource } from '@landsbankinn/l16n';
import { getYear } from 'date-fns';
import { useMemo } from 'react';
import res from './ReturnsSelectorTabs.res';

export function useNominalReturnsOptions() {
  const { r } = useResource();
  const currentYear = getYear(new Date());

  return useMemo(
    () => [
      {
        id: NominalReturnOptions.YearToDateReturn.toString(),
        label: r(res.yearToDate),
      },
      {
        id: NominalReturnOptions.OneMonthReturn.toString(),
        label: r(res.oneMonth),
      },
      {
        id: NominalReturnOptions.ThreeMonthReturn.toString(),
        label: r(res.threeMonths),
      },
      {
        id: NominalReturnOptions.SixMonthReturn.toString(),
        label: r(res.sixMonths),
      },
      {
        id: NominalReturnOptions.OneYearPast.toString(),
        label: (currentYear - 1).toString(),
      },
      {
        id: NominalReturnOptions.TwoYearPast.toString(),
        label: (currentYear - 2).toString(),
      },
      {
        id: NominalReturnOptions.ThreeYearPast.toString(),
        label: (currentYear - 3).toString(),
      },
      {
        id: NominalReturnOptions.FourYearPast.toString(),
        label: (currentYear - 4).toString(),
      },
      {
        id: NominalReturnOptions.FiveYearPast.toString(),
        label: (currentYear - 5).toString(),
      },
    ],
    [currentYear],
  );
}

export function useAnnualizedReturnsOptions() {
  const { r } = useResource();

  return useMemo(
    () => [
      {
        id: AnnualizedReturnOptions.OneYear.toString(),
        label: r(res.oneYear),
      },
      {
        id: AnnualizedReturnOptions.TwoYears.toString(),
        label: r(res.twoYears),
      },
      {
        id: AnnualizedReturnOptions.ThreeYears.toString(),
        label: r(res.threeYears),
      },
      {
        id: AnnualizedReturnOptions.FourYears.toString(),
        label: r(res.fourYears),
      },
      {
        id: AnnualizedReturnOptions.FiveYears.toString(),
        label: r(res.fiveYears),
      },
    ],
    [r],
  );
}

export enum NominalReturnOptions {
  OneMonthReturn,
  ThreeMonthReturn,
  SixMonthReturn,
  YearToDateReturn,
  OneYearPast,
  TwoYearPast,
  ThreeYearPast,
  FourYearPast,
  FiveYearPast,
}

export enum AnnualizedReturnOptions {
  OneYear,
  TwoYears,
  ThreeYears,
  FourYears,
  FiveYears,
}
